import {LEAD_FORM} from "../../constants/app-constants";
const appointmentFlow = [
    "selectedInspectionType",
    "selectedBranch",
    "selectedInspectionDate",
    "selectedInspectionTime"
];

const oneStepAppointmentFlow = [
    "selectedInspectionType",
    "selectedBranch",
    "selectedInspectionDate",
    "selectedInspectionTime",
    "selectedBrand",
    "selectedModel"
];

export const reset = (stepName, leadFormType) => {
    const selectedFlow = leadFormType === LEAD_FORM.ONE_STEP ? oneStepAppointmentFlow : appointmentFlow;
    const currentStep = selectedFlow.indexOf(stepName);
    const resettable = {};
    selectedFlow.slice(currentStep + 1)
        .forEach(step => {
            resettable[step] = null;
        });
    return resettable;
};
